const org = 'ls'
export const API = {
  Integral: {
    // 获取积分
    getPoints: `/access/v1/user/info`,
    // 下面这两个是旧的接口
    // 获取可兑换券列表
    getIntegralTicket: type => `/v1/integral-mall/goods/ticket/${type}/list`,
    // 兑换券
    postIntegralTicket: (id, count = 1) => `/access/v1/integral-mall/goods/exchange/${id}/${count}`,
    // 新接口
    // 获取积分兑换券的列表
    getIntegralList: `/v2/integral-mall/goods/ticket/list`,
    // 获取积分明细(remove)
    getIntegralDetailsList: `/access/v1/user/integral/log`,
    // 获取积分获取记录和消耗记录
    getIntegralLog: (type, month) => `/access/v2/user/integral/log/${type}/${month}`
  },

  Tutorial: {
    getList: type => `/v1/school/${type}/list`
  },
  Coupon: {
    getCouponList: `/access/v1/${org}/account/other/ticket`
  },
  User: {
    postCaptchaRequest: phone => `/v1/user/password/forget/captcha/${phone}`,
    postLoginRequest: `/v2/user/login`,
    postLoginRequestV3: `/v3/user/login`,
    postFeeToday: `/access/v1/user/sum/fee/today`
  },
  Transaction: {
    //  持仓单详情
    getHoldOrderDetails: (orderId) => `/access/v1/${org}/order/hold/info/${orderId}`
  },
  Address: {
    // 获取列表
    getList: `/access/v1/${org}/delivery/address/{isDefault}`,
    // 设置默认地址
    setAddress: id => `/access/v1/${org}/delivery/address/default/${id}`,
    // 新建
    putAddress: `/access/v1/${org}/delivery/address`,
    // 删除
    deleteAddress: (id) => `/access/v1/${org}/delivery/address/${id}`,
    // 修改
    postAddress: (id) => `/access/v1/${org}/delivery/address/${id}`
  },
  Delivery: {
    // 订单确认收货 method: GET
    confirmOrder: orderNum => `/access/v1/${org}/confirm/received/${orderNum}`,
    //  提货商品询价
    getDeliveryPrice: `/access/v1/${org}/delivery/enquiry`,
    //  退订订单商品询价
    getDeliveryUnsubscriptionPrice: `/access/v1/${org}/deliverysuborder/enquiry`,
    //  新建
    putAddress: `/access/v1/${org}/delivery/address`,
    //  删除
    deleteAddress: (addressId) => `/access/v1/${org}/delivery/address/${addressId}`,
    //  修改
    postAddress: (addressId) => `/access/v1/${org}/delivery/address/${addressId}`,
    //  提交实物交割订单
    postDeliveryOrder: `/access/v1/${org}/order/delivery`,
    //  提交退订提货订单
    postDeliveryUnsubscriptionOrder: `/access/v1/${org}/order/deliverysuborder`
  },
  Mall: {
    // banner
    getBanner: `/v1/shop/banner/8`,
    // category
    getCategories: `/v1/shop/catalogs`,
    // label
    getLabels: `/v1/shop/labels`,
    // product
    getProducts: `/v1/shop/products`,
    getProductDetails: id => `/v1/shop/products/${id}`,
    // shopping-cart
    postCartItem: `/access/v1/shop/${org}/cars`,
    putCartItem: `/access/v1/shop/${org}/cars`,
    deleteCartItem: id => `/access/v1/shop/${org}/cars/${id}`,
    getCartData: `/access/v1/shop/${org}/cars`,
    // 创建订单
    postOrder: `/access/v1/shop/${org}/order`,
    // 付款
    postPay: `/access/v1/shop/${org}/order/pay`,
    // 获取订单列表
    getOrder: `/access/v1/shop/${org}/order`,
    // 获取订单详情
    getOrderDetails: orderId => `/access/v1/shop/${org}/order/${orderId}`,
    // 取消订单
    cancelOrder: orderId => `/access/v1/shop/${org}/order/${orderId}`
  },
  Turntable: {
    // 获取用户抽奖记录
    getLotteryLog: '/access/v1/turntable-game/log',
    // 获取用户抽奖相关信息（次数、积分等）
    getLotteryConfig: '/access/v1/turntable-game/user/config',
    // 获取奖品列表
    getPrizeList: '/v1/turntable-game',
    // 获取中奖用户记录
    getLotteryUser: '/access/v1/turntable-game/home/log',
    // 发起抽奖请求
    postLottery: '/access/v1/turntable-game'
  },
  RedPacket: {
    requestPacket: redPackageId => `/access/v1/red-package/open/${redPackageId}`,
    getPacketList: `/v1/red-package/list`,
    getPacketRecord: redPackageId => `/vi/red-package/integralRecord/${redPackageId}`
  },
  CardGame: {
    // 抽奖记录
    getLotteryLog: '/access/v1/card-game/log',
    // 用户抽奖信息
    getLotteryConfig: '/access/v1/card-game/user/config',
    // 中奖用户记录
    getLotteryUser: '/access/v1/card-game/home/log',
    // 发起抽奖
    postLottery: '/access/v1/card-game'
  },
  EggSmash: {
    // 这命名真是太艹了，小英雄看多了
    // 抽奖记录
    getLotteryLog: '/access/v1/smash-egg-game/log',
    // 用户抽奖信息
    getLotteryConfig: '/access/v1/smash-egg-game/user/config',
    // 中奖用户记录
    getLotteryUser: '/access/v1/smash-egg-game/home/log',
    // 发起抽奖
    postLottery: '/access/v1/smash-egg-game'
  },
  PigSmash: {
    // 抽奖记录
    getLotteryLog: '/access/v1/smash-pig-game/log',
    // 用户抽奖信息
    getLotteryConfig: '/access/v1/smash-pig-game/user/config',
    // 中奖用户记录
    getLotteryUser: '/access/v1/smash-pig-game/home/log',
    // 发起抽奖
    postLottery: '/access/v1/smash-pig-game'
  },
  LuckyBag: {
    // 抽奖记录
    getLotteryLog: '/access/v1/fortune-bag-game/log',
    // 用户抽奖信息
    getLotteryConfig: '/access/v1/fortune-bag-game/user/config',
    // 中奖用户记录
    getLotteryUser: '/access/v1/fortune-bag-game/home/log',
    // 发起抽奖
    postLottery: '/access/v1/fortune-bag-game'
  },
  Task: {
    // 每日任务
    getList: '/access/v1/everyDayTask',
    putTask: taskId => `/access/v1/everyDayTask/${taskId}`
  }
}
